import { useMatch, useParams } from 'react-router';
import useRecruitmentSpec from '../../api/useRecruitmentSpec';
import CandidatesOverviewNavigationSidebar from '@/Components/CandidatesOverview/CandidatesOverviewNavigationSidebar';
import RoutePath from '@/Routing/RoutePath';

const AiSearchNavigationSidebar = () => {
    const { data } = useRecruitmentSpec();

    const isAgenticSearchSelected = !!useMatch(RoutePath.AgenticAiSearch);
    const isIdentifiedAiSearchSelected = !!useMatch(RoutePath.IdentifiedAiSearch);
    const isShortlistedAiSearchSelected = !!useMatch(RoutePath.ShortlistedAiSearch);
    const params = useParams();
    const companyId = params.companyId || '';
    const clientId = data?.clientId || '';

    return (
        <CandidatesOverviewNavigationSidebar
            clientId={clientId}
            companyId={companyId}
            recruitmentName={data?.name}
            jobLocation={data?.jobLocation}
            isAgenticSearchSelected={isAgenticSearchSelected}
            isIdentifiedAiSearchSelected={isIdentifiedAiSearchSelected}
            isShortlistedAiSearchSelected={isShortlistedAiSearchSelected}
        />
    );
};

export default AiSearchNavigationSidebar;
